import { EImportErrorCode } from '../enums/import-error-code.enum';

export class ImportPatientError extends Error {
  constructor(
    message: string,
    public readonly code?: EImportErrorCode
  ) {
    super(message);
  }
}
